import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class AssignmentFollowService {
  private httpClient = inject(HttpClient);

  private assignmnetFollowsUrl = '';

  public setAssignmentFollowsUrl(projectId: string) {
    this.assignmnetFollowsUrl = `${environment.apiUrl}/projects/${projectId}/assignments`;
  }

  public addAssignmentFollower(id: string): Observable<null> {
    return this.httpClient.post<null>(this.getFollowsUrl(id), null);
  }

  public removeAssignmentFollower(id: string): Observable<null> {
    return this.httpClient.delete<null>(this.getFollowsUrl(id));
  }

  public checkFollow(id: string): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.getFollowsUrl(id)}/check-follow`);
  }

  private getFollowsUrl(assignmentId: string): string {
    return `${this.assignmnetFollowsUrl}/${assignmentId}/follows`;
  }
}
